import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import FAQSection from './components/FAQSection';
import { getFeaturedArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import { Link } from 'react-router-dom';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '艳姆1—6系列解析站',
  url: typeof window !== 'undefined' ? window.location.origin : '',
  description:
    '艳姆1—6完整系列介绍与内容解析，提供各集剧情详解、人物设定分析及观看指引。',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: '/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '艳姆系列解析团队',
  url: typeof window !== 'undefined' ? window.location.origin : '',
  description:
    '专注于动画系列深度内容解析与分享的创作团队',
};

export default function Home() {
  const featuredArticles = getFeaturedArticles().slice(0, 6);

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '艳姆1—6完整系列介绍与内容解析 - 首页',
    description:
      '艳姆1—6是备受关注的动画系列作品，本页全面介绍艳姆1—6各集内容概要、人物设定、剧情发展及系列亮点。',
    url: typeof window !== 'undefined' ? window.location.href : '',
    isPartOf: {
      '@type': 'WebSite',
      name: '艳姆1—6系列解析站',
      url: typeof window !== 'undefined' ? window.location.origin : '',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <Navbar />
      <main>
        <HeroBanner />
        <FeaturedArticles />
        <CategoryGrid />

        <section className="py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  最新文章
                </h2>
                <p className="text-foreground-600 mt-2 text-sm">
                  持续更新的艳姆1—6系列深度内容
                </p>
              </div>
              <Link
                to="/category/plot-analysis"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
              >
                更多文章
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        <FAQSection />

        <section className="py-16 md:py-20 bg-accent-500">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
              准备好深入了解艳姆1—6了吗？
            </h2>
            <p className="text-background-100/80 mb-8 leading-relaxed text-sm">
              从第1集到第6集，从人物分析到幕后故事，我们为您准备了最全面的系列解析内容
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/plot-analysis"
                className="px-8 py-3 rounded-full bg-background-50 text-accent-600 font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                开始阅读
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 rounded-full bg-accent-600 text-background-50 font-medium text-sm hover:bg-accent-700 transition-colors whitespace-nowrap"
              >
                关于我们
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}